import React from 'react';
import CommonCtaArea from '../../components/CommonCtaArea/CommonCtaArea';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import Footer from '../../components/shared/Footer';
import PageHelmet from '../../components/shared/PageHelmet';
import HomeOneHeader from '../Home/HomeOneHeader/HomeOneHeader';
import TeamDetailsArea from './TeamDetailsArea/TeamDetailsArea';

const TeamDetails = () => {
   return (
      <>
         <PageHelmet pageTitle="Careers" />

         <HomeOneHeader/>
         <CommonPageHeader title="Join our Team" subtitle="Careers" />
         <TeamDetailsArea/>
         <CommonCtaArea/>
         <Footer/>
      </>
   );
};

export default TeamDetails;